import React, { useEffect, useState, useMemo } from 'react'
import { YHModal } from '@/components/YHModal'
import { YhBox } from '@/components/YhBox'
import { Table, Button, Tooltip, Result, Input } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { formatNum, momentFormat } from '@/utils/utils'
import { IDetailsFindPageField } from '../stock/delivery/stockOutDispatchType'
import { stockOutDispatchService } from '../stock/delivery/stockOutDispatchService'
import useGlobalModel from '@/model/globalModel'
import { ShopStock } from './shopStock'
import { DescriptionColorEnum } from '@/components/YhBox/Types'
import { roleColumnModel } from "@/utils/roleColumn";
import YhTootip from '@/components/YhTootip'

interface IHistoryModelType {
    visible: boolean
    materialCode: string
    materialName: string
    onCancel: () => void
}
export const HistoryModel = ({
    //采购销售历史通用查询弹框
    visible,
    materialCode,
    materialName,
    onCancel,
}: IHistoryModelType) => {
    const { shopAndOrg: { shopId }, user: { roles } } = useGlobalModel()
    const { getRoleColumns } = roleColumnModel();
    const [dataSource, setDataSource] = useState<IDetailsFindPageField[]>([])
    const [type, setType] = useState('purchase')
    // 总数
    const [numTotal, setNumTotal] = useState<number>(0)
    useEffect(() => {
        visible && getStockStatistic('purchase')
    }, [visible])

    const numFlage = (orderType: string, num: number) => {
        switch (orderType) {
            case '采购':
                return num
            case '采购退货':
                return -num
            case '销售':
                return num
            case '维修':
                return num
            case '销售退单':
                return -num
            case '维修退单':
                return -num
            default:
                return
        }
    }
    const getStockStatistic = async (historyType: string, customerName?: string) => {
        let params = {
            pageSize: 2000,
            pageNum: 1,
            materialCode,
            shopId,
            customerName,
        }
        let total = 0
        let { retData } = historyType === 'purchase' ? await stockOutDispatchService.purchaseHistory(params) : await stockOutDispatchService.saleHistory(params)
        const { records } = retData
        let newRecords = records.map((item) => {
            return {
                ...item,
                historyName: historyType === 'purchase' ? item?.supplierName : item?.customerName,
            }
        })
        let newData = records.map((item) => {
            return {
                ...item,
                num: numFlage(item.orderType as string, Number(item.num)),
            }
        })
        if (type !== 'allShop') {
            newData.forEach((item) => {
                let { num } = item
                total += item.num as number
            })
        }
        setNumTotal(total)
        setDataSource(newRecords)
    }
    const action = (
        <>
            <Button
                className={`mr-5 ${type === 'purchase' ? 'tab-buts-active' : ''}`}
                type="primary"
                shape="round"
                onClick={() => {
                    getStockStatistic('purchase')
                    setType('purchase')
                }}
            >
                采购历史
            </Button>
            <Button
                className={`mr-5 ${type === 'sale' ? 'tab-buts-active' : ''}`}
                type="primary"
                shape="round"
                onClick={() => {
                    getStockStatistic('sale')
                    setType('sale')
                }}
            >
                销售历史
            </Button>
            <Button
                className={`mr-5 ${type === 'allShop' ? 'tab-buts-active' : ''}`}
                type="primary"
                shape="round"
                onClick={() => {
                    setType('allShop')
                }}
            >
                各站点库存
            </Button>
            {type === 'sale' && (
                <div className="flex justify-center" style={{ float: 'right' }}>
                    <span className="label-name">客户名称：</span>
                    <Input
                        style={{ width: 260 }}
                        placeholder="请输入客户名称"
                        onChange={(e) => { getStockStatistic('sale', e.target.value) }}
                    />
                </div>
            )}
        </>
    )

    const desc: any[] = [
        {
            label: type === 'purchase' ? '采购总数' : '销售总数',
            value: numTotal,
            color: DescriptionColorEnum.green,
        },
    ]
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1,
        },
        {
            title: '单据编号',
            width: 160,
            dataIndex: 'orderCode',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '单据类型',
            width: 160,
            dataIndex: 'orderType',
        },
        {
            title: '制单时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text),
        },
        {
            title: type === 'purchase' ? '供应商名称' : '客户名称',
            width: 160,
            dataIndex: 'historyName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '单价',
            width: 120,
            dataIndex: 'price',
        },
        {
            title: '数量',
            width: 80,
            dataIndex: 'num',
        },
        {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            render: (text) => (text === 0 ? '100%' : text + '%'),
        },
        {
            title: '总计',
            width: 80,
            dataIndex: 'amount',
            // render: (text,record) => text ? text : (+formatNum(record.num) * record.price * (1 - record.discountRate))
        },
    ]

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "other", "roleCodes": roles };
        return getRoleColumns("other", "配件历史", columns, params);
    }, [roles, dataSource]);

    return (
        <YHModal
            visible={visible}
            title={`商品名称:${materialName} 商品编码：${materialCode}`}
            onCancel={onCancel}
            width={'70%'}
            bodyHeight={730}
            showFooter={false}
        >
            {/* <Result
            title="系统升级/维护中..."
            extra={
                <Button type="primary" key="console" onClick={onCancel}>
                    关闭
                </Button>
            }
        /> */}
            <YhBox title={action} descriptions={type !== 'allShop' ? desc : []}>
                {/* {type !== 'allShop' ? (
                     <Table
bordered
                        style={{ cursor: 'pointer' }}
                        rowKey={(record) => record.id as string}
                        columns={columns}
                        dataSource={dataSource}
                        scroll={{ x: 'max-content', y: 550 }}
                        pagination={false}
                    />
                ) : (
                    <ShopStock materialCode={materialCode} materialName={materialName} />
                )} */}
                {type === 'allShop' && <ShopStock materialCode={materialCode} materialName={materialName} />}
                {type === 'purchase' && (
                    <Table
                        bordered
                        style={{ cursor: 'pointer' }}
                        rowKey={(record) => record.id as string}
                        columns={roleColumns}
                        dataSource={dataSource}
                        scroll={{ x: 'max-content', y: 550 }}
                        pagination={false}
                    />
                )}
                {type === 'sale' && (
                    <Table
                        bordered
                        style={{ cursor: 'pointer' }}
                        rowKey={(record) => record.id as string}
                        columns={roleColumns}
                        dataSource={dataSource}
                        scroll={{ x: 'max-content', y: 550 }}
                        pagination={false}
                    />
                )}
            </YhBox>
        </YHModal>
    )
}
